/* Ecrilo — mur d'avis (hydratation du rendu serveur).
 * Données : App Proxy relatif /apps/proxy/v1 (pages, tri, vote, dépôt). Les
 * cartes sont clonées depuis le <template> du snippet : un seul gabarit visuel.
 * Tolérant aux pannes : une erreur se voit dans la console, jamais dans la page. */
(function () {
  "use strict";
  var doc = document;
  

  /* Le pays d'un avis : son drapeau quand on sait le dessiner, son nom
     toujours. Le drapeau n'est pas redessiné ici — il est cloné depuis le
     réservoir que le mur a rendu, si bien que les tracés vivent à un seul
     endroit, dans `ecrilo-flag`. Rien ne s'affiche si le mur a désactivé les
     pays, ou si l'avis n'en porte pas. */
  function posePays(cible, nom) {
    if (!cible) return;
    cible.textContent = "";
    var bloc = doc.querySelector("[data-ec-reviews]");
    if (!bloc || bloc.getAttribute("data-pays") !== "1") return;
    var pays = (nom || "").trim();
    if (!pays) return;

    var enveloppe = doc.createElement("span");
    enveloppe.className = "ec-pays";
    var reservoir = doc.querySelector("[data-ec-rev-drapeaux]");
    var source = reservoir && reservoir.querySelector('[data-pays="' + pays.replace(/"/g, '\\"') + '"] svg');
    if (source) enveloppe.appendChild(source.cloneNode(true));
    var texte = doc.createElement("span");
    texte.textContent = pays;
    enveloppe.appendChild(texte);
    cible.appendChild(enveloppe);
  }

  /* Signature d'un avis : prénom, puis l'initiale du nom s'il y en a un.
     Même règle que `ecrilo-review-card.liquid` — les cartes rendues par le
     serveur et celles hydratées ici doivent se ressembler au caractère près.
     Le pays n'est plus affiché ; une lettre change de casse, « #7 » non, ce qui
     évite de signer « Client #. » un avis repris de la marketplace d'origine. */
  function signature(nom) {
    var n = (nom || "").trim();
    if (!n) return "Client";
    var mots = n.split(/\s+/);
    if (mots.length < 2) return mots[0];
    var ini = mots[mots.length - 1].charAt(0).toUpperCase();
    return ini !== ini.toLowerCase() ? mots[0] + " " + ini + "." : mots[0];
  }

  function $(sel, root) { return (root || doc).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function json(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ Accept: "application/json" }, opts.headers || {});
    opts.credentials = "same-origin";
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok) { var e = new Error("HTTP " + r.status); e.data = d; throw e; }
        return d;
      });
    });
  }
  function track(action, params) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
      Shopify.analytics.publish("ecrilo:" + action, { ecrilo: true, catalog: "media_interaction", action: action, component_id: "C12", params: params || {} });
    } } catch (e) {}
  }
  function stars(note, size) {
    var n = Math.max(0, Math.min(5, Number(note) || 0));
    var s = doc.createElement("span"); s.className = "ec-stars"; s.style.fontSize = (size || 15) + "px";
    s.setAttribute("role", "img"); s.setAttribute("aria-label", n.toFixed(1).replace(".", ",") + " sur 5");
    var b = doc.createElement("span"); b.className = "ec-stars__base"; b.setAttribute("aria-hidden", "true"); b.textContent = "★★★★★";
    var f = doc.createElement("span"); f.className = "ec-stars__fill"; f.setAttribute("aria-hidden", "true"); f.style.width = (n * 20) + "%"; f.textContent = "★★★★★";
    s.appendChild(b); s.appendChild(f); return s;
  }
  function dateFr(iso) {
    var d = new Date(/^\d{4}-\d{2}-\d{2}$/.test(iso || "") ? iso + "T12:00:00" : iso); if (isNaN(d)) return "";
    try { return d.toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }); } catch (e) { return iso.slice(0, 10); }
  }
  var voted = {};
  try { voted = JSON.parse(localStorage.getItem("ecrilo:reviews:voted") || "{}"); } catch (e) {}

  function monter(root) {
    if (root.dataset.ecMounted === "1") return; root.dataset.ecMounted = "1";
    var endpoint = root.getAttribute("data-endpoint") || "/apps/proxy/v1";
    var product = root.getAttribute("data-product");
    var parPage = parseInt(root.getAttribute("data-par-page") || "8", 10);
    var total = parseInt(root.getAttribute("data-total") || "0", 10);
    var grid = $("[data-ec-rev-grid]", root), tpl = $("[data-ec-rev-card-tpl]", root);
    var more = $("[data-ec-rev-loadmore]", root), moreWrap = $("[data-ec-rev-more-wrap]", root);
    var shown = $("[data-ec-rev-shown]", root), state = $("[data-ec-rev-state]", root);
    var sortSel = $("[data-ec-rev-sort]", root);
    // Continuité : l'App Proxy pagine sans offset, la page 2 doit commencer juste après les cartes du miroir.
    if (grid.children.length) parPage = grid.children.length;
    var page = 1, sort = (sortSel && sortSel.value) || "pertinent", hasNext = total > grid.children.length, loading = false;

    function setState(msg) { if (!state) return; state.hidden = !msg; state.textContent = msg || ""; }
    function updateShown() { if (shown) shown.textContent = grid.children.length + " affiché" + (grid.children.length > 1 ? "s" : "") + " sur " + total; if (moreWrap) moreWrap.hidden = !hasNext; }

    function carte(a) {
      var li = tpl.content.firstElementChild.cloneNode(true);
      li.setAttribute("data-id", a.id); li.setAttribute("data-rating", a.rating);
      $("[data-slot=stars]", li).replaceWith(stars(a.rating, 15));
      if (a.verified_buyer) $("[data-slot=badge]", li).hidden = false;
      var t = (a.title || "").trim(), b = (a.body || "").trim();
      if (t && t.toLowerCase() !== b.toLowerCase()) { var et = $("[data-slot=title]", li); et.textContent = t; et.hidden = false; }
      if (b) { var eb = $("[data-slot=body]", li); eb.textContent = b; eb.hidden = false; }
      var photos = (a.media || []).filter(function (m) { return !m.kind || m.kind === "image"; });
      if (photos.length) {
        var ph = $("[data-slot=photos]", li); ph.hidden = false;
        photos.forEach(function (m) {
          var img = doc.createElement("img"); img.className = "ec-rev-card__photo"; img.src = m.thumbnail_url || m.thumbnail || m.src; img.alt = "Photo envoyée par " + signature(a.author_name); img.loading = "lazy"; img.decoding = "async"; img.width = 96; img.height = 96;
          ph.appendChild(img);
        });
      }
      if (a.reply) { var er = $("[data-slot=reply]", li); var st = doc.createElement("strong"); st.textContent = "Réponse d'Ecrilo —"; er.appendChild(st); er.appendChild(doc.createTextNode(" " + a.reply)); er.hidden = false; }
      $("[data-slot=author]", li).textContent = signature(a.author_name);
      posePays($("[data-slot=pays]", li), a.author_location);
      $("[data-slot=date]", li).textContent = dateFr(a.submitted_at);
      var hb = $("[data-ec-rev-helpful]", li); hb.setAttribute("data-id", a.id); $("[data-ec-rev-help-count]", hb).textContent = "(" + (a.helpful_count || 0) + ")";
      return li;
    }

    function charger(reset, pageVoulue, triVoulu) {
      if (loading) return; loading = true; if (more) more.disabled = true;
      var pg = pageVoulue || page, tri = triVoulu || sort;
      setState(reset ? "Chargement des avis…" : "");
      json(endpoint + "/reviews?product=" + encodeURIComponent(product) + "&limit=" + parPage + "&page=" + pg + "&sort=" + encodeURIComponent(tri))
        .then(function (d) {
          page = pg; sort = tri;   // confirmés seulement après réponse : un échec ne saute pas de page
          if (reset) grid.innerHTML = "";
          (d.reviews || d.results || []).forEach(function (a) { if (!a.id || !$('[data-id="' + a.id + '"]', grid)) grid.appendChild(carte(a)); });
          hasNext = !!d.has_next;
          if (d.summary) { total = d.summary.count || total; majResume(d.summary); }
          setState(grid.children.length ? "" : "Aucun avis pour l'instant. Le vôtre sera le premier.");
          updateShown(); lierCartes();
        })
        .catch(function (e) { setState("Les avis n'ont pas pu être chargés. Réessayez dans un instant."); if (window.console) console.warn("[Ecrilo avis]", e && e.message, e && e.data); })
        .then(function () { loading = false; if (more) more.disabled = false; });
    }

    function majResume(s) {
      var avg = $("[data-ec-rev-avg]", root), cnt = $("[data-ec-rev-count]", root), reco = $("[data-ec-rev-reco] span", root), st = $("[data-ec-rev-stars]", root);
      if (avg) avg.textContent = Number(s.average || 0).toFixed(1).replace(".", ",");
      if (cnt) cnt.textContent = s.count || 0;
      var lbl = $("[data-ec-rev-count-label]", root); if (lbl) lbl.textContent = s.count ? "avis" : "avis pour l'instant — le vôtre sera le premier";
      var zero = !s.count; [$(".ec-reviews__avgline", root), $("[data-ec-rev-stars]", root), $("[data-ec-rev-reco]", root), $("[data-ec-rev-dist]", root)].forEach(function (el) { if (el) el.hidden = zero; });
      if (reco && s.recommend_pct != null) reco.textContent = s.recommend_pct + " %";
      if (st) { st.innerHTML = ""; st.appendChild(stars(s.average, 22)); }
      var dist = s.distribution || {}, n = s.count || 0;
      $$("[data-ec-rev-dist] .ec-reviews__dist-row", root).forEach(function (row) {
        var k = row.getAttribute("data-note"), v = Number(dist[k] || 0);
        $(".ec-reviews__dist-fill", row).style.width = (n ? Math.round(v * 100 / n) : 0) + "%";
        $(".ec-reviews__dist-num", row).textContent = v;
      });
    }

    function lierCartes() {
      $$("[data-ec-rev-helpful]", grid).forEach(function (b) {
        if (b.dataset.bound) return; b.dataset.bound = "1";
        var id = b.getAttribute("data-id");
        if (voted[id]) { b.classList.add("is-voted"); b.setAttribute("aria-pressed", "true"); }
        b.addEventListener("click", function () {
          if (voted[id] || !id) return;
          b.disabled = true;
          json(endpoint + "/reviews/" + encodeURIComponent(id) + "/helpful?product=" + encodeURIComponent(product), { method: "POST" })
            .then(function (d) {
              voted[id] = 1; try { localStorage.setItem("ecrilo:reviews:voted", JSON.stringify(voted)); } catch (e) {}
              b.classList.add("is-voted"); b.setAttribute("aria-pressed", "true"); $("[data-ec-rev-help-count]", b).textContent = "(" + (d.helpful_count != null ? d.helpful_count : "+1") + ")";
              track("review_helpful", { review_id: id });
            })
            .catch(function (e) { if (window.console) console.warn("[Ecrilo avis] vote", e && e.message); })
            .then(function () { b.disabled = false; });
        });
      });
    }

    // Tri + pagination
    if (sortSel) sortSel.addEventListener("change", function () { charger(true, 1, sortSel.value); track("review_sort", { sort: sortSel.value }); });
    if (more) more.addEventListener("click", function () { charger(false, page + 1); track("review_more", { page: page + 1 }); });

    // Dépôt d'avis
    var modal = $("[data-ec-rev-modal]", root), form = $("[data-ec-rev-form]", root), msg = $("[data-ec-rev-msg]", root);
    var opener = $("[data-ec-rev-open]", root);
    if (opener && modal) {
      opener.addEventListener("click", function () {
        if (modal.showModal) { modal.showModal(); var first = $("[name=body]", form); if (first) first.focus(); } else modal.setAttribute("open", "");
        track("review_form_open");
      });
      $("[data-ec-rev-close]", root).addEventListener("click", function () { modal.close ? modal.close() : modal.removeAttribute("open"); });
      modal.addEventListener("click", function (e) {   // un clic hors du formulaire ne jette pas un texte commencé
        if (e.target !== modal || !modal.close) return;
        var body = $("[name=body]", form); if (body && body.value.trim()) return;
        modal.close();
      });
    }
    if (form) {
      var ratingInput = $("[name=rating]", form);
      $$("[data-ec-rev-rating] .ec-rev-form__star", form).forEach(function (star) {
        star.addEventListener("click", function () {
          var v = Number(star.getAttribute("data-val")); ratingInput.value = v;
          $$("[data-ec-rev-rating] .ec-rev-form__star", form).forEach(function (s) { var on = Number(s.getAttribute("data-val")) <= v; s.classList.toggle("is-on", on); s.setAttribute("aria-checked", Number(s.getAttribute("data-val")) === v ? "true" : "false"); });
        });
      });
      form.addEventListener("submit", function (ev) {
        ev.preventDefault();
        if (!form.checkValidity()) { form.reportValidity(); return; }
        var fd = new FormData(form), payload = {};
        fd.forEach(function (v, k) { payload[k] = v; });
        payload.rating = Number(payload.rating); payload.consent = !!fd.get("consent");
        var submit = $("[type=submit]", form); submit.disabled = true; msg.textContent = "Envoi…";
        json(endpoint + "/reviews?product=" + encodeURIComponent(product), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) })
          .then(function (d) {
            msg.textContent = d.message || "Merci ! Votre avis sera publié après validation.";
            form.reset(); ratingInput.value = 5;
            $$("[data-ec-rev-rating] .ec-rev-form__star", form).forEach(function (s) { s.classList.add("is-on"); s.setAttribute("aria-checked", s.getAttribute("data-val") === "5" ? "true" : "false"); });
            track("review_submit", { rating: payload.rating });
            setTimeout(function () { if (modal.close) modal.close(); msg.textContent = ""; }, 2200);
          })
          .catch(function (e) {
            // RFC 7807 côté serveur : `errors` (champ → messages) pour un 400, `detail` pour 403/404/429.
            var d = e.data || {}, parts = [];
            if (d.errors && typeof d.errors === "object") Object.keys(d.errors).forEach(function (k) { var v = d.errors[k]; parts.push(Array.isArray(v) ? v.join(" ") : String(v)); });
            else if (typeof d.detail === "string") parts.push(d.detail);
            msg.textContent = parts.length ? parts.join(" ") : (e.message === "HTTP 429" ? "Trop d'envois, réessayez dans quelques minutes." : "L'envoi a échoué. Réessayez dans un instant.");
          })
          .then(function () { submit.disabled = false; });
      });
    }

    updateShown(); lierCartes();
    if (!grid.children.length) charger(true);   // pas de miroir (produit B, ou miroir pas encore synchronisé) : on charge
  }

  function monterTout() { $$("[data-ec-reviews]").forEach(monter); }
  if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", monterTout); else monterTout();
  doc.addEventListener("shopify:section:load", monterTout);
})();
